import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_3 = { class: "control-label col-sm-6" }
const _hoisted_4 = { class: "col-sm" }
const _hoisted_5 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_6 = { class: "control-label col-sm-6" }
const _hoisted_7 = { class: "col-sm" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "row crm:items-center crm:mb-6" }
const _hoisted_10 = { class: "control-label col-sm-6" }
const _hoisted_11 = { class: "col-sm" }
const _hoisted_12 = {
  key: 0,
  class: "row crm:items-center crm:mb-6"
}
const _hoisted_13 = { class: "control-label col-sm-6" }
const _hoisted_14 = { class: "col-sm" }

import { watch, ref, inject} from 'vue'
import { usePreventivo } from '../../composable/usePreventivo'
import FormAltroHelper from "../../pages/preventivi/json/altro/helper.json";
import DettaglioPreventivoHelper from "../../pages/preventivi/json/dettagliopreventivo/helper.json";
import RegimeFiscale from "./RegimeFiscale.vue";
import CalcoloEquoCompenso from "./CalcoloEquoCompenso.vue";

export default {
  __name: 'FormAltroCertificazioni',
  props: {
  formName: String,
  tipoPreventivo: Object,
  disabilita: Boolean,
  readonly: Boolean
},
  emits: ['changeDatiPreventivo', 'infoCompilazione'],
  setup(__props, { emit: __emit }) {

const {
  categorieValidazione
} = usePreventivo()
const props = __props
const emits = __emit
let validazione;
const validazioneEquoCompenso = ref();
const { regimeFiscale } = inject('regimeFiscale')
switch (props.formName) {
  case 'relazioneVentennale':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaCertificazioni']['relazioneVentennale']
    validazioneEquoCompenso.value = categorieValidazione.categoriaAltro['sottocategoriaCertificazioni']['relazioneVentennale']
    break
  case 'giuramento':
    validazione = categorieValidazione.categoriaAltro['sottocategoriaCertificazioni']['giuramento']
    validazioneEquoCompenso.value  = categorieValidazione.categoriaAltro['sottocategoriaCertificazioni']['giuramento']
    break
}
const testoInfoCompilazione = ref([]);
testoInfoCompilazione.value =  FormAltroHelper.sottocategoriaCertificazioni[props.formName];
emits('infoCompilazione',  testoInfoCompilazione);
// Aggiungiamo il valore a tipo_parametro che sarà un path alla pagina (mantenendo il nome)
if (validazione) {
  validazione.tipo_preventivo.value = 'altro/certificazioni/' + props.tipoPreventivo.data.url
}
watch(validazione, (newValue, oldValue) => {
  emits('changeDatiPreventivo')
}, { deep: true })
let indexHelperClosing = {
  calcolo: FormAltroHelper.sottocategoriaCertificazioni[props.formName],
  dettaglio: DettaglioPreventivoHelper.dettaglioPreventivo.descrizioni
}

return (_ctx, _cache) => {
  const _component_the_helper = _resolveComponent("the-helper")
  const _component_base_input_text = _resolveComponent("base-input-text")
  const _component_base_input_checkbox = _resolveComponent("base-input-checkbox")
  const _directive_fallcohelper = _resolveDirective("fallcohelper")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_the_helper, {
      list: _unref(indexHelperClosing),
      "is-closing": true
    }, null, 8 /* PROPS */, ["list"]),
    (__props.formName === 'relazioneVentennale')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_input_text, {
                id: "numero_marche_da_bollo",
                name: "numero_marche_da_bollo",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero marche da bollo",
                "readonly:": "",
                Boolean: "",
                "validate-to": _unref(validazione).numero_marche_da_bollo,
                "onUpdate:validateTo": _cache[0] || (_cache[0] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
              }, null, 8 /* PROPS */, ["validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[1] || (_cache[1] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.formName === 'giuramento')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_10, [
              _createTextVNode(_toDisplayString(_unref(validazione).numero_marche_da_bollo.label), 1 /* TEXT */)
            ])), [
              [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.numero_marche_da_bollo.ref]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_base_input_text, {
                id: "numero_marche_da_bollo",
                name: "numero_marche_da_bollo",
                class: "placeholder-right crm:text-right",
                placeholder: "Indicare numero marche da bollo",
                "readonly:": "",
                Boolean: "",
                "validate-to": _unref(validazione).numero_marche_da_bollo,
                "onUpdate:validateTo": _cache[2] || (_cache[2] = $event => ((_unref(validazione).numero_marche_da_bollo) = $event))
              }, null, 8 /* PROPS */, ["validate-to"])
            ])
          ]),
          (_unref(regimeFiscale) == 'ordinario')
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_13, [
                  _createTextVNode(_toDisplayString(_unref(validazione).ritenuta_acconto.label), 1 /* TEXT */)
                ])), [
                  [_directive_fallcohelper, _unref(indexHelperClosing).calcolo.ritenuta_acconto.ref]
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_base_input_checkbox, {
                    class: _normalizeClass(props.disabilita ? 'crm:opacity-20 crm:pointer-events-none':''),
                    name: "ritenuta_acconto",
                    label: "Si, applicabile",
                    "validate-to": _unref(validazione).ritenuta_acconto,
                    "onUpdate:validateTo": _cache[3] || (_cache[3] = $event => ((_unref(validazione).ritenuta_acconto) = $event))
                  }, null, 8 /* PROPS */, ["class", "validate-to"])
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createVNode(RegimeFiscale, {
            validazione: _unref(validazione),
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"]),
          _createVNode(CalcoloEquoCompenso, {
            "input-riferimento-calcolo": "",
            validazione: validazioneEquoCompenso.value,
            helper: _unref(indexHelperClosing),
            readonly: __props.readonly,
            "filter-options-d": true
          }, null, 8 /* PROPS */, ["validazione", "helper", "readonly"])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}